import styled from 'styled-components';

// Styled components for UserList component
export const PopupWindow = styled.div`
    width: 150px;
    height: auto;
    min-height: 100px;
    position: fixed;
    top: ${(props) => props.top}px;
    left: ${(props) => props.left}px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 100000;
    background: linear-gradient(180deg, rgba(30, 35, 50, 0.98) 0%, rgba(22, 28, 42, 0.99) 100%);
    border: 1px solid rgba(100, 150, 200, 0.2);
`;

export const QuickActionsContainer = styled.div`
    display: flex;
    gap: 8px;
    margin-right: 5px;
    opacity: 1;
    transition: opacity 0.2s ease;
`;

export const QuickActionButton = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.05);
    transition: background-color 0.2s ease;
    
    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
    
    img {
        width: 16px;
        height: 16px;
        filter: brightness(0) invert(0.9);
        opacity: 0.9;
    }
`;

export const UserContainer = styled.div`
    background: ${(props) => (props.$isSelected ? 'linear-gradient(90deg, rgba(60, 100, 160, 0.2) 0%, rgba(40, 55, 85, 0.15) 100%)' : 'transparent')};
    display: flex;
    padding: 12px 14px;
    gap: 12px;
    align-items: center;
    cursor: pointer;
    position: relative;
    border-left: ${(props) => (props.$isSelected ? '3px solid rgba(80, 140, 220, 0.9)' : '3px solid transparent')};
    transition: border-left 0.2s ease, background 0.2s ease;

    &:hover {
      background: linear-gradient(90deg, rgba(60, 100, 160, 0.15) 0%, rgba(40, 55, 85, 0.1) 100%);
    }

    @media (max-width: 768px) {
      padding: 10px 12px;
    }
`;

/* --- Multi-line lead row (Option B: name+date line, then a chips line) --- */
export const UserBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 7px;
    flex: 1;
    min-width: 0;
    padding-top: 1px;
`;

export const UserBodyTop = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
`;

export const UserName = styled.span`
    flex: 1;
    min-width: 0;
    color: rgba(255, 255, 255, 0.95);
    font-size: 14.5px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
      font-size: 13.5px;
    }
`;

export const UserWhen = styled.span`
    flex-shrink: 0;
    color: rgba(255, 255, 255, 0.55);
    font-size: 11.5px;
    font-weight: 400;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
`;

export const UserChipsRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    min-width: 0;
`;

/* Right column: date/time + ⋮ on top, status pill right-aligned beneath. */
export const UserRightCol = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
`;

export const UserRightTop = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const UserImage = styled.img`
    width: 35px;
    height: 35px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    @media (max-width: 768px) {
      width: 30px;
      height: 30px;
    }
`;

export const InitialsAvatar = styled.div`
    width: ${props => props.$size || '35px'};
    height: ${props => props.$size || '35px'};
    border-radius: ${props => props.$radius || '8px'};
    background: ${props => props.$bg || '#6366f1'};
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 600;
    font-size: ${props => props.$fontSize || '14px'};
    letter-spacing: 0.5px;
    text-transform: uppercase;
    flex-shrink: 0;
    border: 1px solid rgba(255, 255, 255, 0.15);
    
    @media (max-width: 768px) {
      width: ${props => props.$sizeSm || '30px'};
      height: ${props => props.$sizeSm || '30px'};
      font-size: ${props => props.$fontSizeSm || '12px'};
    }
`;

export const UserInfoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    color: rgba(255, 255, 255, 0.9);
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

export const UserDetails = styled.div`
    display: flex;
    flex-direction: column;
    color: rgba(255, 255, 255, 0.9);
    min-width: 0;
    overflow: hidden;

    span:first-child {
        color: rgba(255, 255, 255, 0.95);
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    span:nth-child(2) {
        color: rgba(255, 255, 255, 0.6);
        font-size: 11.5px;
        font-weight: 400;
        margin-top: 2px;
    }

    @media (max-width: 768px) {
        span:first-child { font-size: 13px; }
        span:nth-child(2) { font-size: 11px; }
    }
`;

export const UserRightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

export const StatusContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-width: 52px;
`;

export const LineContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 0;
    
    div {
      height: 1px;
      width: 90%;
      background: linear-gradient(90deg, transparent, rgba(100, 150, 200, 0.2), transparent);
    }
`;

export const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, rgba(35, 45, 65, 0.6) 0%, rgba(30, 40, 60, 0.7) 100%);
  border-radius: 8px;
  padding: 6px 12px;
  width: 90%;
  border: 1px solid rgba(100, 150, 200, 0.15);
  transition: all 0.2s ease;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
  
  &:focus-within {
    border-color: rgba(80, 140, 220, 0.5);
    box-shadow: 0 0 0 2px rgba(80, 140, 220, 0.2), inset 0 1px 3px rgba(0, 0, 0, 0.15);
  }

  img {
    width: 18px;
    height: 18px;
    filter: brightness(0) invert(0.9);
    opacity: 0.9;
  }
`;

export const SearchInput = styled.input`
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  padding: 4px 0;
  margin-left: 8px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
    transition: color 0.2s;
  }
  
  &:focus::placeholder {
    color: rgba(255, 255, 255, 0.2);
  }
`;

export const Dot = styled.div`
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
`;

export const DotsContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 15px;
    justify-content: space-between;
    cursor: pointer;
    padding: 0 4px;
`;

export const FilterWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  img {
    width: 22px;
    height: 22px;
    filter: brightness(0) invert(0.9);
    opacity: 0.9;
  }
`;

export const PopupWindowItem = styled.div`
  padding-left: .5vw;
  padding-right: .5vw;
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  cursor: ${props => props.$isDisabled ? 'not-allowed' : 'pointer'};
  background: transparent;
  color: ${props => props.$isDisabled ? 'rgba(180, 195, 220, 0.5)' : 'rgba(200, 220, 255, 0.9)'};
  width: 100%;
  opacity: ${props => props.$isDisabled ? 0.7 : 1};
  transition: background 0.2s ease;
  
  &:hover {
    background: ${props => props.$isDisabled ? 'transparent' : 'linear-gradient(90deg, rgba(60, 100, 160, 0.2) 0%, rgba(40, 55, 85, 0.15) 100%)'};
  }
  
  img {
    filter: ${props => props.$isDisabled ? 'brightness(0) invert(0.5)' : 'brightness(0) invert(0.9)'};
    opacity: ${props => props.$isDisabled ? '0.5' : '1'};
    width: ${props => props.$isRemoveIcon ? '20px' : '18px'};
    height: ${props => props.$isRemoveIcon ? '20px' : '18px'};
  }
`;

export const PopupIconWrapper = styled.div`
  float: right;
  width: ${({ $isRemoveIcon }) => $isRemoveIcon ? '26px' : '24px'};
  height: ${({ $isRemoveIcon }) => $isRemoveIcon ? '26px' : '24px'};

  > img {
    width: 100%;
    height: 100%;
    filter: brightness(0) invert(0.9);
  }
`;

export const UserListContainer = styled.div`
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  margin: 0;
  margin-top: 10px;
  
  background: linear-gradient(180deg, rgba(30, 35, 50, 0.95) 0%, rgba(20, 25, 40, 0.98) 100%);
  border-radius: 12px;
  position: relative;
  height: calc(93vh - 10px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(100, 150, 200, 0.15);

  /* Ensure child elements respect the border radius */
  & > * {
    border-radius: inherit;
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 10px;
  background: transparent;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const HeaderContainer = styled.div`
  padding: 10px 10px;
  background: linear-gradient(90deg, rgba(25, 30, 45, 0.98) 0%, rgba(35, 45, 65, 0.95) 100%);
  border-bottom: 1px solid rgba(100, 150, 200, 0.2);
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  border-radius: 12px 12px 0 0;
  gap: 10px;
  height: 42px;
  justify-content: space-between; /* Add justify-content to position items */
`;

export const HeaderTitle = styled.span`
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.2px;
  font-family: "Roboto",-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 18px;
    height: 18px;
    filter: brightness(0) invert(1);
  }
`;

// Add new styled components for the filter popup
export const FilterPopup = styled.div`
  position: absolute;
  width: 250px;
  background: linear-gradient(180deg, rgba(30, 35, 50, 0.98) 0%, rgba(22, 28, 42, 0.99) 100%);
  border: 1px solid rgba(100, 150, 200, 0.2);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  z-index: 10000;
  right: 15px;
  top: 60px;
  padding: 12px;
`;

export const FilterSection = styled.div`
  margin-bottom: 15px;
`;

export const FilterTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 10px 0;
`;

export const FilterOption = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
`;

export const FilterCheckbox = styled.div`
  width: 16px;
  height: 16px;
  border: 1px solid rgba(100, 150, 200, 0.4);
  border-radius: 3px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.checked ? 'linear-gradient(135deg, rgba(60, 120, 200, 0.9) 0%, rgba(80, 140, 220, 0.95) 100%)' : 'transparent'};
`;

export const FilterLabel = styled.span`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
`;

export const FilterRadioOption = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
`;

export const FilterRadio = styled.div`
  width: 16px;
  height: 16px;
  border: 1px solid rgba(100, 150, 200, 0.4);
  border-radius: 50%;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &:after {
    content: '';
    display: ${props => props.checked ? 'block' : 'none'};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(60, 120, 200, 0.95) 0%, rgba(80, 140, 220, 1) 100%);
    position: absolute;
  }
`;

export const FilterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
`;

export const FilterButton = styled.button`
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid ${props => props.primary ? 'rgba(80, 140, 220, 0.3)' : 'rgba(100, 150, 200, 0.2)'};
  background: ${props => props.primary ? 'linear-gradient(135deg, rgba(60, 120, 200, 0.85) 0%, rgba(80, 140, 220, 0.9) 100%)' : 'rgba(40, 50, 70, 0.5)'};
  color: rgba(200, 220, 255, 0.95);
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.primary ? 'linear-gradient(135deg, rgba(70, 130, 210, 0.95) 0%, rgba(90, 150, 230, 1) 100%)' : 'rgba(50, 65, 90, 0.7)'};
  }
`;

// Info popup styled components
export const UserInfoPopup = styled.div`
  position: fixed;
  width: 400px;
  max-height: 520px;
  background: linear-gradient(135deg, rgba(25, 30, 50, 0.98) 0%, rgba(20, 25, 45, 0.98) 100%);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  z-index: 100001;
  border: 1px solid rgba(99, 102, 241, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const PopupHeader = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%);
  border-bottom: 1px solid rgba(99, 102, 241, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PopupTitle = styled.h3`
  margin: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.3px;
`;

export const CloseButton = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    color: #fff;
  }
`;

export const PopupContent = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  
  /* Modern scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(99, 102, 241, 0.4);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(99, 102, 241, 0.6);
  }
`;

export const InfoSection = styled.div`
  margin-bottom: 20px;
`;

export const InfoSectionTitle = styled.h4`
  margin: 0 0 12px 0;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid rgba(99, 102, 241, 0.2);
  padding-bottom: 8px;
  letter-spacing: 0.3px;
`;

export const InfoRow = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const InfoLabel = styled.div`
  width: 110px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-weight: 500;
`;

export const InfoValue = styled.div`
  color: rgba(255, 255, 255, 0.95);
  font-size: 13px;
  word-break: break-word;
  flex: 1;
  font-weight: 500;
`;

export const UserHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(99, 102, 241, 0.15);
`;

export const UserHeaderImageWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  border: 2px solid rgba(99, 102, 241, 0.3);
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.2);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    width: 54px;
    height: 54px;
  }
`;

export const UserHeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  
  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

export const UserHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserHeaderName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
  letter-spacing: 0.3px;
`;

export const UserHeaderStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
`;

export const ConversationHistoryPopup = styled(UserInfoPopup)`
  width: 480px;
  max-height: 640px;
`;

export const MessageContainer = styled.div`
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 10px;
  background: ${props => {
    if (props.messageType === 'gpt' || props.messageType === 'bot') {
      return 'linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(37, 99, 235, 0.3) 100%)';
    } else if (props.messageType === 'system') {
      return 'linear-gradient(135deg, rgba(168, 85, 247, 0.25) 0%, rgba(147, 51, 234, 0.3) 100%)';
    } else if (props.isSelf) {
      return 'linear-gradient(135deg, rgba(16, 185, 129, 0.25) 0%, rgba(5, 150, 105, 0.3) 100%)';
    } else {
      return 'linear-gradient(135deg, rgba(71, 85, 105, 0.95) 0%, rgba(51, 65, 85, 0.98) 100%)';
    }
  }};
  backdrop-filter: blur(8px);
  border: 1px solid ${props => {
    if (props.messageType === 'gpt' || props.messageType === 'bot') {
      return 'rgba(59, 130, 246, 0.3)';
    } else if (props.messageType === 'system') {
      return 'rgba(168, 85, 247, 0.3)';
    } else if (props.isSelf) {
      return 'rgba(16, 185, 129, 0.3)';
    } else {
      return 'rgba(148, 163, 184, 0.2)';
    }
  }};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`;

export const MessageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

export const MessageSender = styled.div`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: ${props => {
    if (props.messageType === 'gpt' || props.messageType === 'bot') {
      return '#93c5fd'; // Blue-300
    } else if (props.messageType === 'system') {
      return '#d8b4fe'; // Purple-300
    } else if (props.isSelf) {
      return '#6ee7b7'; // Emerald-300
    } else {
      return '#cbd5e1'; // Slate-300
    }
  }};
  margin-bottom: 6px;
  opacity: 1;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
`;

export const MessageTime = styled.div`
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  letter-spacing: 0.2px;
`;

export const MessageContent = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
  white-space: pre-wrap;
  line-height: 1.6;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const SystemMessage = styled(MessageContainer)`
  background-color: #532a66; // Same purple as system messages in main chat
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

export const SystemMessageSender = styled(MessageSender)`
  color: rgba(220, 180, 255, 1); // Light purple for system sender names
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
`;

export const DateDivider = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0;
  
  &:before, &:after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  span {
    padding: 0 10px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const ConfirmDialog = styled.div`
  position: fixed;
  width: 330px;
  background-color: #1E1E1E;
  border-radius: 8px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  z-index: 100001;
  border: 1px solid rgba(255, 255, 255, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ConfirmHeader = styled.div`
  padding: 15px;
  background-color: rgb(46 48 52);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ConfirmTitle = styled.h3`
  margin: 0;
  color: rgba(255, 255, 255, 0.95);
  font-size: 16px;
  font-weight: 500;
`;

export const ConfirmContent = styled.div`
  padding: 15px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 1.5;
`;

export const ConfirmActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px 15px;
  gap: 10px;
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  
  &:focus {
    outline: none;
  }
`;

export const CancelButton = styled(ConfirmButton)`
  background-color: #333;
  color: rgba(255, 255, 255, 0.9);
  
  &:hover {
    background-color: #444;
  }
`;

export const DeleteButton = styled(ConfirmButton)`
  background-color: #d32f2f;
  color: white;
  
  &:hover {
    background-color: #b71c1c;
  }
`;

export const PopupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  gap: 10px;
`;

export const FooterButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background-color: ${props => props.primary ? '#2f88f5' : '#333'};
  color: white;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${props => props.primary ? '#1c6fd4' : '#444'};
  }
  
  &:focus {
    outline: none;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
`;

export const ActionButton = styled.button`
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  background-color: ${props => props.color || '#333'};
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  
  &:hover {
    filter: brightness(1.1);
  }
  
  img {
    width: 14px;
    height: 14px;
    filter: brightness(0) invert(1);
  }
`;

export const FilterStatusBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #2f88f5;
  border: 2px solid #1E1E1E;
  display: ${props => props.show ? 'block' : 'none'};
`;

// Help popup styled components
export const HelpPopup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #1E1E1E;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
  width: 700px;
  max-width: 90vw;
  max-height: 80vh;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const HelpPopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
`;

export const HelpPopupTitle = styled.h2`
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 500;
`;

export const HelpPopupContent = styled.div`
  padding: 20px;
  overflow-y: auto;
  color: rgba(255, 255, 255, 0.9);

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
  }
`;

export const HelpSection = styled.div`
  margin-bottom: 25px;
`;

export const HelpSectionTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 10px;
  color: #2f88f5;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 5px;
`;

export const HelpSectionContent = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
`;

export const HelpFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
`;

export const HelpCloseButton = styled.button`
  background-color: #2f88f5;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1c6fd4;
  }
`;

export const ComponentImage = styled.div`
  background-color: #252525;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 10px;
  margin: 10px 0;
  display: flex;
  align-items: center;
`;

// Assignment Submenu Styles
export const AssignmentSubmenu = styled.div`
  position: absolute;
  left: 100%;
  top: 0;
  width: 220px;
  background: linear-gradient(180deg, rgba(30, 35, 50, 0.98) 0%, rgba(22, 28, 42, 0.99) 100%);
  border: 1px solid rgba(100, 150, 200, 0.2);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  z-index: 100001;
  padding: 8px 0;
  margin-left: 5px;
`;

export const AssignmentSubmenuHeader = styled.div`
  padding: 10px 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const AssignmentPersonItem = styled.div`
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(47, 136, 245, 0.15);
  }
`;

export const AssignmentPersonAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2f88f5 0%, #1c6fd4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 500;
`;

export const AssignmentPersonInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const AssignmentPersonName = styled.span`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AssignmentPersonEmail = styled.span`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AddPersonButton = styled.div`
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 5px;
  color: #2f88f5;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(47, 136, 245, 0.1);
  }
`;

export const AddPersonIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px dashed rgba(47, 136, 245, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2f88f5;
  font-size: 18px;
`;

export const AssignedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  width: fit-content;
  gap: 3px;
  background: linear-gradient(135deg, rgba(47, 136, 245, 0.15) 0%, rgba(47, 136, 245, 0.08) 100%);
  border: 1px solid rgba(47, 136, 245, 0.25);
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 9px;
  color: #64b5f6;
  white-space: nowrap;
  margin-top: 2px;
`;

export const AddPersonModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 380px;
  background: linear-gradient(180deg, rgba(30, 35, 50, 0.98) 0%, rgba(22, 28, 42, 0.99) 100%);
  border: 1px solid rgba(100, 150, 200, 0.2);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 100002;
  padding: 0;
  overflow: hidden;
`;

export const AddPersonModalHeader = styled.div`
  padding: 18px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AddPersonModalTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
`;

export const AddPersonModalContent = styled.div`
  padding: 20px;
`;

export const AddPersonInput = styled.input`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(100, 150, 200, 0.2);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin-bottom: 15px;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #2f88f5;
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

export const AddPersonModalFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: rgba(0, 0, 0, 0.1);
`;

export const ModalButton = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  
  ${props => props.$primary ? `
    background: linear-gradient(135deg, #2f88f5 0%, #1c6fd4 100%);
    color: white;
    
    &:hover {
      background: linear-gradient(135deg, #1c6fd4 0%, #1558a8 100%);
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  ` : `
    background: transparent;
    color: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.2);
    
    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  `}
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100001;
`;

// Tab components for Leads/Incomplete toggle
export const TabContainer = styled.div`
  display: flex;
  gap: 0;
  padding: 0 16px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const Tab = styled.button`
  flex: 1;
  padding: 12px 16px;
  background: transparent;
  border: none;
  border-bottom: 2px solid ${props => props.$active ? '#2f88f5' : 'transparent'};
  color: ${props => props.$active ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.5)'};
  font-size: 13px;
  font-weight: ${props => props.$active ? '600' : '400'};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    color: rgba(255, 255, 255, 0.8);
    background: rgba(255, 255, 255, 0.03);
  }
`;

export const TabBadge = styled.span`
  background: ${props => props.$active ? '#2f88f5' : 'rgba(255, 255, 255, 0.15)'};
  color: ${props => props.$active ? 'white' : 'rgba(255, 255, 255, 0.7)'};
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  margin-left: 6px;
  font-weight: 500;
`;

// Incomplete lead specific styles
export const IncompleteLeadContainer = styled.div`
  background: ${props => props.$isSelected 
    ? 'linear-gradient(90deg, rgba(60, 100, 160, 0.2) 0%, rgba(40, 55, 85, 0.15) 100%)' 
    : props.$isHidden ? 'rgba(255, 255, 255, 0.02)' : 'transparent'};
  opacity: ${props => props.$isHidden ? 0.6 : 1};
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  cursor: pointer;
  position: relative;
  border-left: ${props => props.$isSelected ? '3px solid rgba(80, 140, 220, 0.9)' : '3px solid transparent'};
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(90deg, rgba(60, 100, 160, 0.15) 0%, rgba(40, 55, 85, 0.1) 100%);
  }
`;

export const IncompleteLeadHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const IncompleteLeadInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const IncompleteLeadContact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ContactItem = styled.span`
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  svg, img {
    width: 14px;
    height: 14px;
    opacity: 0.7;
  }
`;

export const IncompleteLeadTime = styled.span`
  color: rgba(255, 255, 255, 0.45);
  font-size: 11px;
`;

export const HiddenBadge = styled.span`
  background: rgba(255, 150, 50, 0.2);
  color: rgba(255, 180, 100, 0.9);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
`;

export const ShowHiddenToggle = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  cursor: pointer;
  
  input {
    cursor: pointer;
  }
`;

// Add Lead Button and Modal styles
export const AddLeadButton = styled.button`
  background: linear-gradient(135deg, rgba(47, 136, 245, 0.9) 0%, rgba(80, 160, 255, 0.9) 100%);
  border: none;
  border-radius: 6px;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(135deg, rgba(47, 136, 245, 1) 0%, rgba(80, 160, 255, 1) 100%);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const AddLeadModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  backdrop-filter: blur(4px);
`;

export const AddLeadModal = styled.div`
  background: linear-gradient(180deg, rgba(30, 40, 60, 0.98) 0%, rgba(20, 28, 45, 0.99) 100%);
  border-radius: 12px;
  border: 1px solid rgba(100, 150, 200, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  width: 90%;
  max-width: 420px;
  overflow: hidden;
`;

export const AddLeadModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  h3 {
    margin: 0;
    color: rgba(255, 255, 255, 0.95);
    font-size: 16px;
    font-weight: 600;
  }
`;

export const CloseModalButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s ease;
  
  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`;

export const AddLeadModalContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AddLeadInput = styled.input`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 12px 14px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  transition: all 0.2s ease;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: rgba(47, 136, 245, 0.6);
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const AddLeadTextarea = styled.textarea`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 12px 14px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  resize: vertical;
  min-height: 70px;
  transition: all 0.2s ease;
  font-family: inherit;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: rgba(47, 136, 245, 0.6);
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const AddLeadModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
`;

// Send Email Modal Styles
export const SendEmailModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100003;
  backdrop-filter: blur(4px);
`;

export const SendEmailModal = styled.div`
  background: linear-gradient(180deg, rgba(30, 40, 60, 0.98) 0%, rgba(20, 28, 45, 0.99) 100%);
  border-radius: 12px;
  border: 1px solid rgba(100, 150, 200, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  width: 90%;
  max-width: 520px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const SendEmailModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%);
  
  h3 {
    margin: 0;
    color: rgba(255, 255, 255, 0.95);
    font-size: 17px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const SendEmailModalContent = styled.div`
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  flex: 1;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(99, 102, 241, 0.4);
    border-radius: 3px;
  }
`;

export const EmailFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const EmailFormLabel = styled.label`
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
`;

export const EmailFormSelect = styled.select`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 12px 14px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: rgba(99, 102, 241, 0.6);
    background: rgba(255, 255, 255, 0.08);
  }
  
  option {
    background: #1a1f2e;
    color: rgba(255, 255, 255, 0.95);
  }
`;

export const EmailFormInput = styled.input`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 12px 14px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  transition: all 0.2s ease;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: rgba(99, 102, 241, 0.6);
    background: rgba(255, 255, 255, 0.08);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EmailFormTextarea = styled.textarea`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 12px 14px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  resize: vertical;
  min-height: 100px;
  transition: all 0.2s ease;
  font-family: inherit;
  line-height: 1.5;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: rgba(99, 102, 241, 0.6);
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const EmailRecipientInfo = styled.div`
  background: rgba(99, 102, 241, 0.1);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const EmailRecipientAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  font-weight: 600;
`;

export const EmailRecipientDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  
  span:first-child {
    color: rgba(255, 255, 255, 0.95);
    font-size: 14px;
    font-weight: 500;
  }
  
  span:last-child {
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
  }
`;

export const SendEmailModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.15);
`;

export const EmailSenderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  
  span {
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const SendEmailButton = styled.button`
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  border: none;
  border-radius: 8px;
  color: white;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EmailButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const EmailCancelButton = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

export const EmailSuccessMessage = styled.div`
  background: rgba(16, 185, 129, 0.15);
  border: 1px solid rgba(16, 185, 129, 0.3);
  border-radius: 8px;
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #34d399;
  font-size: 14px;
`;

export const EmailErrorMessage = styled.div`
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #f87171;
  font-size: 14px;
`;

// Signature Templates Styles
export const SignatureTemplatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 180px;
  overflow-y: auto;
  padding: 4px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(99, 102, 241, 0.4);
    border-radius: 3px;
  }
`;

export const SignatureTemplateItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: ${props => props.$selected 
    ? 'rgba(99, 102, 241, 0.15)' 
    : 'rgba(255, 255, 255, 0.03)'};
  border: 1px solid ${props => props.$selected 
    ? 'rgba(99, 102, 241, 0.4)' 
    : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 8px;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  opacity: ${props => props.$disabled ? 0.5 : 1};
  
  &:hover {
    background: ${props => props.$disabled 
      ? 'rgba(255, 255, 255, 0.03)' 
      : props.$selected 
        ? 'rgba(99, 102, 241, 0.2)' 
        : 'rgba(255, 255, 255, 0.06)'};
    border-color: ${props => props.$disabled 
      ? 'rgba(255, 255, 255, 0.1)' 
      : 'rgba(99, 102, 241, 0.3)'};
  }
`;

export const SignatureTemplateIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: ${props => props.$type === 'pdf' 
    ? 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(239, 68, 68, 0.1) 100%)' 
    : 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(59, 130, 246, 0.1) 100%)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
`;

export const SignatureTemplateInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  
  span:first-child {
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  span:last-child {
    color: rgba(255, 255, 255, 0.5);
    font-size: 11px;
  }
`;

export const SignatureTemplateCheck = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${props => props.$selected 
    ? '#6366f1' 
    : 'rgba(255, 255, 255, 0.2)'};
  background: ${props => props.$selected 
    ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)' 
    : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.2s ease;
  flex-shrink: 0;
`;

export const SignupLinkDialog = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  background: linear-gradient(165deg, #1e293b 0%, #0f172a 100%);
  border: 1px solid rgba(99, 102, 241, 0.25);
  border-radius: 16px;
  padding: 28px;
  width: 440px;
  max-width: 90vw;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(99, 102, 241, 0.1);
`;

export const SignupDialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
`;

export const SignupDialogTitle = styled.h3`
  color: rgba(255, 255, 255, 0.95);
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SignupDialogField = styled.div`
  margin-bottom: 16px;
  
  label {
    display: block;
    color: rgba(255, 255, 255, 0.6);
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
  }
`;

export const SignupDialogInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  
  &:focus {
    border-color: rgba(99, 102, 241, 0.5);
  }
  
  &:read-only {
    color: rgba(255, 255, 255, 0.5);
    cursor: default;
  }
`;

export const SignupDialogLinkBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  
  span {
    flex: 1;
    color: rgba(99, 102, 241, 0.9);
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const SignupDialogCopyBtn = styled.button`
  padding: 4px 10px;
  background: rgba(99, 102, 241, 0.2);
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 6px;
  color: #a5b4fc;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(99, 102, 241, 0.3);
  }
`;

export const SignupDialogActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`;

export const SignupDialogSendBtn = styled.button`
  flex: 1;
  padding: 10px 16px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SignupDialogCloseBtn = styled.button`
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const SignupDialogStatus = styled.div`
  margin-top: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  background: ${props => props.$error 
    ? 'rgba(239, 68, 68, 0.1)' 
    : 'rgba(34, 197, 94, 0.1)'};
  border: 1px solid ${props => props.$error 
    ? 'rgba(239, 68, 68, 0.2)' 
    : 'rgba(34, 197, 94, 0.2)'};
  color: ${props => props.$error ? '#f87171' : '#4ade80'};
`;